export default __webpack_public_path__ + "8d81916.png";